import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { GroupSelectionRow } from "../../../Components/StagedSelection/GroupStage/GroupSelectionRow";
import { SelectPredictionTypeTabs } from "../../../Components/PredictionSelection/SelectPredictionTypeTabs";
import { PredictionTypeEnum } from "../../../Domain/Enums/PredictionTypeEnum";
import { LeaderboardCard } from "../../../Components/PredictionSelection/Leaderboard/LeaderboardCard";
import { useStore } from "../../../Store/useStore";
import { CompetitionPaper } from "../../../Components/PredictionSelection/CompetitionPaper";
import { Wsm2026Prediction } from "../../../Domain/Aggregates/CompetitionPrediction/Wsm2026Prediction";
import { EventCardListWithoutStoneOff } from "../../../Components/PredictionSelection/IndividualEvents/EventCardListWithoutStoneOff";


export const Wsm2026GroupsComponent = () => {

	const competitionPrediction = useStore((state) => state.competitionPrediction) as Wsm2026Prediction;
	const predictionForCurrentGroup = useStore((state) => state.getPredictionForCurrentGroup());
	const changePredictionTypeFor = useStore((state) => state.changePredictionTypeFor);
	const isReadOnly = useStore((state) => state.isReadOnly);

	const changePredictionType = React.useCallback((predictionType: PredictionTypeEnum) => {
		changePredictionTypeFor(competitionPrediction.SelectedGroup.Id, predictionType);
	}, [competitionPrediction.SelectedGroup.Id]);

	// If SelectedGroup is undefined, don't render the component
	if (!competitionPrediction.SelectedGroup || !predictionForCurrentGroup) {
		return null;
	}

	return (
		<Box>
			<GroupSelectionRow groups={competitionPrediction.Competition.Heats} />

			<CompetitionPaper>

				{!isReadOnly && (
					<Box>
						<SelectPredictionTypeTabs
							predictionType={predictionForCurrentGroup.PredictionType}
							setPredictionType={changePredictionType}
							leaveSpaceForButtons={true}
						/>

						<Typography variant="h6" component="div">
							Your
							<Typography
								variant="h6"
								component="span"
								color="warning.light"
							>
								{` ${competitionPrediction.SelectedGroup.Name} `}
							</Typography>
							Predictions:
						</Typography>
					</Box>
				)}

				{predictionForCurrentGroup.PredictionType === PredictionTypeEnum.Leaderboard ? (
					<LeaderboardCard
						stageId={competitionPrediction.SelectedGroup.Id}
						isFinal={competitionPrediction.SelectedGroup.IsFinal}
					/>
				) : predictionForCurrentGroup.PredictionType === PredictionTypeEnum.Events ? (
					<EventCardListWithoutStoneOff stage={competitionPrediction.SelectedGroup} />
				) : (
					<h6>Prediction type not recognised or set</h6>
				)}

			</CompetitionPaper>
		</Box>
	);
};
